import axios, {AxiosResponse} from "axios"
import {getSisDateAsNumber} from "util/SisDateTime";
import {vlErrorMapper} from 'module/PersonInfo/util/vlErrorMapper';
import _ from "lodash";
import {VlFehl} from 'generated/JavaTOmodifications';

export const fetchVerrBis = (persNr: number) => axios.get<number>('../json/persInfo', {params: {persNr}});

export const fetchVlErrors = (persNr: number) => axios.get('../json/vlErrors', {params: {persNr}})
	.then((resp): (AxiosResponse & { data: VlFehl[] }) => ({
		...resp,
		data: _.map(resp.data, vlErrorMapper),
	}))

export const fetchPersonInfo = (persNr: number, date: number) => axios.get<string[]>('../json/personal-info', {
	params: {
		persNr,
		date: getSisDateAsNumber(date),
	},
})